// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.wrapper-user {
  display: flex;
  flex-direction: column;
  gap: 35px;
  padding: 20px;
}
.wrapper-user .group-dropdown-overlay .ant-dropdown-menu {
  min-width: 180px !important;
  max-width: 180px !important;
  overflow: visible !important;
}
.wrapper-user .group-dropdown-overlay .ant-dropdown-menu .ant-dropdown-menu-item {
  padding: 5px 12px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wrapper-user .custom-dropdown-menu {
  background-color: var(--color-surface-overlay);
  border-radius: 4px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  overflow: visible !important;
}

.wrapper-search {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

.wrapper-search__size {
  display: flex;
  align-items: center;
}

.wrapper-search__search {
  margin-left: 16px;
  cursor: pointer;
}

.fz-20 {
  font-size: 20px;
}

.fz-40 {
  font-size: 40px;
}

.cursor-pointer {
  cursor: pointer;
}

.wrapper-search__size .ant-select {
  width: 100px;
  height: 40px;
}

.ant-table {
  margin-top: 16px;
}

.ant-modal {
  text-align: center;
}

.custom-modal .ant-modal-content {
  padding: 24px;
  border-radius: 8px;
}
.custom-modal .ant-modal-header {
  margin-bottom: 8px;
}
.custom-modal .ant-modal-title {
  font-size: 18px;
  font-weight: 600;
}
.custom-modal .ant-modal-footer {
  margin-top: 24px;
  border-top: none;
  padding: 0;
}
.custom-modal .ant-btn {
  height: 32px;
  padding: 4px 16px;
  border-radius: 4px;
  font-weight: 500;
}

.group-filter-container {
  padding-top: 0 !important;
  margin-top: -8px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  padding-left: 50px;
  height: 50px;
}
.group-filter-container .group-dropdown-button {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  background-color: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: background var(--duration-base) var(--easing-standard), border-color var(--duration-base) var(--easing-standard), box-shadow var(--duration-base) var(--easing-standard);
  font-size: 14px;
  font-weight: var(--fw-medium);
  color: var(--color-text);
  font-family: var(--font-sans);
  width: 200px;
  height: 40px;
  box-sizing: border-box;
}
.group-filter-container .group-dropdown-button:hover {
  background-color: var(--color-bg-subtle);
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px var(--color-primary-ring);
}
.group-filter-container .group-dropdown-button .anticon {
  margin-left: auto;
  font-size: 12px;
  color: var(--color-text-subtle);
}
.group-filter-container .group-dropdown-button .ant-space {
  width: 100%;
  justify-content: space-between;
}
.group-filter-container .ant-dropdown.ant-dropdown-placement-bottomLeft .ant-dropdown-menu, .group-filter-container .ant-dropdown.ant-dropdown-placement-bottomRight .ant-dropdown-menu, .group-filter-container .ant-dropdown.ant-dropdown-placement-bottom .ant-dropdown-menu {
  min-width: 180px;
}

.group-item-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.group-item-container .delete-group-button {
  opacity: 0;
  transition: all 0.3s;
}
.group-item-container:hover .delete-group-button {
  opacity: 0.6;
}

.delete-group-button {
  transition: all 0.3s;
}
.delete-group-button:hover {
  opacity: 1 !important;
  color: #ff4d4f !important;
  background: transparent !important;
}

.add-group-input-container {
  display: flex;
  width: 100%;
  padding: 0;
}
.add-group-input-container .ant-input {
  width: 100%;
  height: 24px;
  font-size: 14px;
  padding: 0 8px;
  box-sizing: border-box;
  max-width: 150px;
}

.group-item-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
}
.group-item-container .group-item-name {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.group-item-container .delete-group-button {
  opacity: 0;
  transition: opacity 0.2s;
}
.group-item-container .delete-group-button:hover {
  opacity: 1;
  color: #ff4d4f;
}

.add-group-input-container {
  padding: 4px 0;
}

/* 테이블 행에 대한 호버 스타일 수정 */
.ant-table-tbody > tr {
  cursor: default; /* 기본 커서를 화살표로 설정 */
  /* 편집 버튼에만 포인터 커서 적용 */
  /* 그 외 모든 셀은 기본 커서 유지 */
}
.ant-table-tbody > tr:hover {
  background-color: #fafafa; /* 호버 배경색은 유지 */
}
.ant-table-tbody > tr .password-edit-button,
.ant-table-tbody > tr .company-edit-button,
.ant-table-tbody > tr .delete-button,
.ant-table-tbody > tr .group-dropdown-trigger {
  cursor: pointer;
}
.ant-table-tbody > tr td {
  cursor: default;
}

/* 그룹 드롭다운 트리거 영역에 포인터 커서 적용 */
.group-dropdown-trigger {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}
.group-dropdown-trigger .dropdown-icon {
  margin-left: 5px;
}

/* 삭제 버튼 컨테이너에 포인터 커서 적용 */
.delete-button-container {
  cursor: default; /* 컨테이너 자체는 기본 커서 */
}
.delete-button-container .delete-button {
  cursor: pointer; /* 버튼에만 포인터 커서 */
}`, "",{"version":3,"sources":["webpack://./src/pages/User/UserStyled.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;AAAF;AAGI;EACE,2BAAA;EACA,2BAAA;EACA,4BAAA;AADN;AAGM;EACE,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AADR;AAME;EAEE,8CAAA;EACA,kBAAA;EACA,oHAAA;EACA,4BAAA;AALJ;;AASA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;AANF;;AASA;EACE,iBAAA;EACA,eAAA;AANF;;AASA;EACE,eAAA;AANF;;AASA;EACE,eAAA;AANF;;AASA;EACE,eAAA;AANF;;AASA;EACE,YAAA;EACA,YAAA;AANF;;AASA;EACE,gBAAA;AANF;;AASA;EACE,kBAAA;AANF;;AAUE;EACE,aAAA;EACA,kBAAA;AAPJ;AAUE;EACE,kBAAA;AARJ;AAWE;EACE,eAAA;EACA,gBAAA;AATJ;AAYE;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;AAVJ;AAaE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAXJ;;AAgBA;EACE,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAbF;AAgBE;EACE,oBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,iCAAA;EACA,qCAAA;EACA,+BAAA;EACA,eAAA;EACA,oLAAA;EAGA,eAAA;EACA,6BAAA;EACA,wBAAA;EACA,6BAAA;EAEA,YAAA;EACA,YAAA;EACA,sBAAA;AAjBJ;AAmBI;EACE,wCAAA;EACA,kCAAA;EACA,+CAAA;AAjBN;AAoBI;EACE,iBAAA;EACA,eAAA;EACA,+BAAA;AAlBN;AAqBI;EACE,WAAA;EACA,8BAAA;AAnBN;AA4BM;EACE,gBAAA;AA1BR;;AAiCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AA9BF;AAiCE;EACE,UAAA;EACA,oBAAA;AA/BJ;AAmCE;EACE,YAAA;AAjCJ;;AAqCA;EACE,oBAAA;AAlCF;AAqCE;EACE,qBAAA;EACA,yBAAA;EACA,kCAAA;AAnCJ;;AAuCA;EACE,aAAA;EACA,WAAA;EACA,UAAA;AApCF;AAsCE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;AApCJ;;AAwCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;AArCF;AAuCE;EACE,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AArCJ;AAwCE;EACE,UAAA;EACA,wBAAA;AAtCJ;AAwCI;EACE,UAAA;EACA,cAAA;AAtCN;;AA2CA;EACE,cAAA;AAxCF;;AA8CA,wBAAA;AACA;EACE,eAAA,EAAA,mBAAA;EAMA,sBAAA;EAQA,uBAAA;AAvDF;AA2CE;EACE,yBAAA,EAAA,eAAA;AAzCJ;AA6CE;;;;EAIE,eAAA;AA3CJ;AA+CE;EACE,eAAA;AA7CJ;;AAiDA,8BAAA;AACA;EACE,eAAA;EACA,oBAAA;EACA,mBAAA;AA9CF;AAgDE;EACE,gBAAA;AA9CJ;;AAkDA,0BAAA;AACA;EACE,eAAA,EAAA,mBAAA;AA/CF;AAiDE;EACE,eAAA,EAAA,gBAAA;AA/CJ","sourcesContent":["// .page-title styling provided globally in src/styles/global.scss (accent bar + bottom hairline).\n\n.wrapper-user {\n  display: flex;\n  flex-direction: column;\n  gap: 35px;\n  padding: 20px;\n\n  .group-dropdown-overlay {\n    .ant-dropdown-menu {\n      min-width: 180px !important;\n      max-width: 180px !important;\n      overflow: visible !important;\n      \n      .ant-dropdown-menu-item {\n        padding: 5px 12px !important;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n  \n  .custom-dropdown-menu {\n    // 드롭다운 패널입니다. 라이트에서는 그대로 #FFFFFF 입니다.\n    background-color: var(--color-surface-overlay);\n    border-radius: 4px;\n    box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n    overflow: visible !important;\n  }\n}\n\n.wrapper-search {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.wrapper-search__size {\n  display: flex;\n  align-items: center;\n}\n\n.wrapper-search__search {\n  margin-left: 16px;\n  cursor: pointer;\n}\n\n.fz-20 {\n  font-size: 20px;\n}\n\n.fz-40 {\n  font-size: 40px;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.wrapper-search__size .ant-select {\n  width: 100px;\n  height: 40px;\n}\n\n.ant-table {\n  margin-top: 16px;\n}\n\n.ant-modal {\n  text-align: center;\n}\n\n.custom-modal {\n  .ant-modal-content {\n    padding: 24px;\n    border-radius: 8px;\n  }\n  \n  .ant-modal-header {\n    margin-bottom: 8px;\n  }\n  \n  .ant-modal-title {\n    font-size: 18px;\n    font-weight: 600;\n  }\n\n  .ant-modal-footer {\n    margin-top: 24px;\n    border-top: none;\n    padding: 0;\n  }\n\n  .ant-btn {\n    height: 32px;\n    padding: 4px 16px;\n    border-radius: 4px;\n    font-weight: 500;\n  }\n}\n\n// 그룹 필터 컨테이너 스타일\n.group-filter-container {\n  padding-top: 0 !important;\n  margin-top: -8px;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  padding-left: 50px;\n  height: 50px;\n\n  // 그룹 드롭다운 버튼 스타일\n  .group-dropdown-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 16px;\n    background-color: var(--color-bg);\n    border: 1px solid var(--color-border);\n    border-radius: var(--radius-md);\n    cursor: pointer;\n    transition: background var(--duration-base) var(--easing-standard),\n                border-color var(--duration-base) var(--easing-standard),\n                box-shadow var(--duration-base) var(--easing-standard);\n    font-size: 14px;\n    font-weight: var(--fw-medium);\n    color: var(--color-text);\n    font-family: var(--font-sans);\n\n    width: 200px;\n    height: 40px;\n    box-sizing: border-box;\n\n    &:hover {\n      background-color: var(--color-bg-subtle);\n      border-color: var(--color-primary);\n      box-shadow: 0 0 0 3px var(--color-primary-ring);\n    }\n\n    .anticon {\n      margin-left: auto;\n      font-size: 12px;\n      color: var(--color-text-subtle);\n    }\n\n    .ant-space {\n      width: 100%;\n      justify-content: space-between;\n    }\n  }\n\n  // 드롭다운 메뉴 크기 조절\n  .ant-dropdown {\n    &.ant-dropdown-placement-bottomLeft,\n    &.ant-dropdown-placement-bottomRight,\n    &.ant-dropdown-placement-bottom {\n      .ant-dropdown-menu {\n        min-width: 180px;\n      }\n    }\n  }\n}\n\n// 그룹 아이템 컨테이너 스타일\n.group-item-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  \n  // 삭제 버튼 기본적으로 숨김\n  .delete-group-button {\n    opacity: 0;\n    transition: all 0.3s;\n  }\n  \n  // 그룹 항목에 호버시 삭제 버튼 표시\n  &:hover .delete-group-button {\n    opacity: 0.6;\n  }\n}\n\n.delete-group-button {\n  transition: all 0.3s;\n  \n  // 삭제 버튼에 호버시 완전히 표시하고 빨간색으로 변경\n  &:hover {\n    opacity: 1 !important;\n    color: #ff4d4f !important;\n    background: transparent !important;\n  }\n}\n\n.add-group-input-container {\n  display: flex;\n  width: 100%;\n  padding: 0;\n  \n  .ant-input {\n    width: 100%;\n    height: 24px;\n    font-size: 14px;\n    padding: 0 8px;\n    box-sizing: border-box;\n    max-width: 150px;\n  }\n}\n\n.group-item-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px 0;\n  \n  .group-item-name {\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  \n  .delete-group-button {\n    opacity: 0;\n    transition: opacity 0.2s;\n    \n    &:hover {\n      opacity: 1;\n      color: #ff4d4f;\n    }\n  }\n}\n\n.add-group-input-container {\n  padding: 4px 0;\n}\n\n// .group-dropdown-button stand-alone definition removed —\n// styling lives inside .wrapper-user .group-dropdown-button above (token-based).\n\n/* 테이블 행에 대한 호버 스타일 수정 */\n.ant-table-tbody > tr {\n  cursor: default; /* 기본 커서를 화살표로 설정 */\n  \n  &:hover {\n    background-color: #fafafa; /* 호버 배경색은 유지 */\n  }\n  \n  /* 편집 버튼에만 포인터 커서 적용 */\n  .password-edit-button,\n  .company-edit-button,\n  .delete-button,\n  .group-dropdown-trigger {\n    cursor: pointer;\n  }\n  \n  /* 그 외 모든 셀은 기본 커서 유지 */\n  td {\n    cursor: default;\n  }\n}\n\n/* 그룹 드롭다운 트리거 영역에 포인터 커서 적용 */\n.group-dropdown-trigger {\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  \n  .dropdown-icon {\n    margin-left: 5px;\n  }\n}\n\n/* 삭제 버튼 컨테이너에 포인터 커서 적용 */\n.delete-button-container {\n  cursor: default; /* 컨테이너 자체는 기본 커서 */\n  \n  .delete-button {\n    cursor: pointer; /* 버튼에만 포인터 커서 */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
